var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPage({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93959 5.77896C6.93959 6.24188 6.56433 6.61715 6.10141 6.61715M6.93959 5.77896C6.93959 5.31605 6.56433 4.94078 6.10141 4.94078M6.93959 5.77896H6.10141M6.10141 6.61715C5.63849 6.61715 5.26323 6.24188 5.26323 5.77896M6.10141 6.61715V5.77896M5.26323 5.77896C5.26323 5.31605 5.63849 4.94078 6.10141 4.94078M5.26323 5.77896H6.10141M6.10141 4.94078V5.77896M10.6067 5.77896C10.6067 6.24188 10.2314 6.61715 9.76848 6.61715M10.6067 5.77896C10.6067 5.31605 10.2314 4.94078 9.76848 4.94078M10.6067 5.77896H9.76848M9.76848 6.61715C9.30557 6.61715 8.9303 6.24188 8.9303 5.77896M9.76848 6.61715V5.77896M8.9303 5.77896C8.9303 5.31605 9.30557 4.94078 9.76848 4.94078M8.9303 5.77896H9.76848M9.76848 4.94078V5.77896M14.2429 5.77896C14.2429 6.24188 13.8676 6.61715 13.4047 6.61715M14.2429 5.77896C14.2429 5.31605 13.8676 4.94078 13.4047 4.94078M14.2429 5.77896H13.4047M13.4047 6.61715C12.9418 6.61715 12.5665 6.24188 12.5665 5.77896M13.4047 6.61715V5.77896M12.5665 5.77896C12.5665 5.31605 12.9418 4.94078 13.4047 4.94078M12.5665 5.77896H13.4047M13.4047 4.94078V5.77896M2 9.22431V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V9.22431M2 9.22431V5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V9.22431M2 9.22431H22",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPage);
export default __webpack_public_path__ + "static/media/page.bc977a62bf4ca2bb51faf4a6f0c0dec0.svg";
export { ForwardRef as ReactComponent };